import { AxiosInstance } from 'axios'
import { Carrier } from '~/carrier/Carrier'
import { EmailInterval } from '~/models/organization/subscription/Interval'

export interface MailSubscriptionDto {
  // eslint-disable-next-line camelcase
  mail_id: string
  token: string
}

export interface MailSubscriptionSettingsDto {
  interval: EmailInterval
}

export class SubscriptionsCarrier extends Carrier {
  constructor(api: AxiosInstance) {
    super(api, 'manage_subscription')
  }

  public get(
    params: MailSubscriptionDto
  ): Promise<{ data: MailSubscriptionSettingsDto }> {
    return this.api.get(this.path, { params })
  }

  public put(
    params: MailSubscriptionDto,
    settings: MailSubscriptionSettingsDto
  ): Promise<{ data: MailSubscriptionSettingsDto }> {
    return this.api.put(this.path, settings, { params })
  }

  public delete(params: MailSubscriptionDto): Promise<void> {
    return this.api.delete(this.path, { params })
  }
}
